"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuoteChangedCard = void 0;
var react_1 = __importDefault(require("react"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var DetailsLine_1 = require("./DetailsLine");
var styles = __importStar(require("./QuoteChangedCard.css"));
var QuoteChangedCard = function (_a) {
    var interactionEventData = _a.interactionEventData, headingButton = _a.headingButton;
    var eventType = interactionEventData.eventType, quoteTotalValue = interactionEventData.quoteTotalValue, lineItems = interactionEventData.lineItems, billingFrequency = interactionEventData.billingFrequency, planCard = interactionEventData.planCard;
    return (react_1.default.createElement(kaleidoscope_1.Stack, { gap: "xs" },
        react_1.default.createElement(kaleidoscope_1.Stack, { direction: "horizontal", justify: "spaceBetween" },
            react_1.default.createElement(kaleidoscope_1.Heading, { strong: true, level: "5", align: "left" }, eventType),
            headingButton),
        !!quoteTotalValue && react_1.default.createElement(DetailsLine_1.DetailsLine, { title: "Quote total", value: quoteTotalValue }),
        !!billingFrequency && react_1.default.createElement(DetailsLine_1.DetailsLine, { title: "Billing frequency", value: billingFrequency }),
        !!(planCard === null || planCard === void 0 ? void 0 : planCard.title) && react_1.default.createElement(DetailsLine_1.DetailsLine, { title: "Plan selected", value: planCard.title }),
        (planCard === null || planCard === void 0 ? void 0 : planCard.quantity) != undefined && react_1.default.createElement(DetailsLine_1.DetailsLine, { title: "Plan quantity updated", value: planCard.quantity }),
        !!lineItems &&
            Object.entries(lineItems).map(function (_a) {
                var _b = __read(_a, 2), key = _b[0], lineItem = _b[1];
                return react_1.default.createElement(LineItemGrouping, { key: key, lineItem: lineItem });
            })));
};
exports.QuoteChangedCard = QuoteChangedCard;
var LineItemGrouping = function (_a) {
    var _b = _a.lineItem, description = _b.description, quantity = _b.quantity, selected = _b.selected;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: styles.dividerLine }),
        !!description && react_1.default.createElement(DetailsLine_1.DetailsLine, { title: "Line item changed", value: description }),
        selected != undefined && react_1.default.createElement(DetailsLine_1.DetailsLine, { title: "Selection", value: selected ? "Selected" : "Unselected" }),
        quantity != undefined && react_1.default.createElement(DetailsLine_1.DetailsLine, { title: "Quantity", value: quantity })));
};
